export const ASX:string = "ASX";
export const LSE:string = "LSE";
export const LME:string = "LME";
export const FSE:string = "FSE";
export const NAS:string = "NAS";
export const OTC:string = "OTC";
export const TSXV:string = "TSXV";